import React, { useRef, useEffect, useState } from "react";
import "../../assets/css/contact.css"; // Assurez-vous que ce fichier existe
import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt, FaClock, FaPhone, FaEnvelope } from "react-icons/fa";
import galleryImage7 from "../../assets/image/galerie4.webp"; // Importez l'image

export default function Contact() {
    const { t } = useTranslation("contact");
    const contactSectionRef = useRef(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsLoaded(true);
                        observer.unobserve(contactSectionRef.current);
                    }
                });
            },
            {
                root: null,
                threshold: 0.2,
            }
        );

        if (contactSectionRef.current) {
            observer.observe(contactSectionRef.current);
        }

        return () => {
            if (contactSectionRef.current) {
                observer.unobserve(contactSectionRef.current);
            }
        };
    }, []);

    return (
        <section
            id="Contact"
            className={`contact-section ${isLoaded ? "loaded" : ""}`}
            ref={contactSectionRef}
        >
            <div className="image-container">
                <img
                    src={galleryImage7}
                    alt="image de contact"
                    className="image_contact"
                />
                <h2 className="contact-title-overlay">{t("title")}</h2>
            </div>
            <div className="contact-info-wrapper">
                <div className="contact-info">
                    <FaMapMarkerAlt className="contact-icon" />
                    <p className="textcontact">
                        {t("operationZone")}:{" "}
                        <span>
                            {t("montreal")}, {t("gatineauOttawa")},{" "}
                            {t("surroundings")}
                        </span>
                    </p>
                </div>
                <div className="contact-info">
                    <FaClock className="contact-icon" />
                    <p className="textcontact">
                        {t("hours")}:{" "}
                        <span>
                            {t("thursday")} - {t("monday")} {t("from")} 07:30 AM{" "}
                            {t("to")} 07:30 PM
                        </span>
                    </p>
                </div>
                <div className="contact-info">
                    <FaPhone className="contact-icon" />
                    <p className="textcontact">
                        {t("contactNumber")}: <span>+1(416) 833-6316</span>
                    </p>
                </div>
                <div className="contact-info">
                    <FaEnvelope className="contact-icon" />
                    <p className="textcontact">
                        {t("emailAddress")}:{" "}
                        <span>mamdjui.cuisine@gmail.com</span>
                    </p>
                </div>
                <a href="#ServiceRequest" className="contact-button">
                    {t("bookingButton")}
                </a>
            </div>
        </section>
    );
}
